<h3 *ngIf="data.id == null" mat-dialog-title>Cadastrar Registro de Contato</h3>
<h3 *ngIf="data.id != null" mat-dialog-title>Alterar Registro de Contato</h3>
<div mat-dialog-content style="padding-top: 10px">
    <div fxLayout="row wrap" *ngIf="showClientField">
        <mat-form-field appearance="outline" fxFlex="100" style="width: 100%">
            <mat-label>Cliente</mat-label>
            <input
                matInput
                placeholder="Digite o nome ou conta de um cliente"
                aria-label="Cliente"
                [formControl]="cliente"
                name="cliente"
                [matAutocomplete]="auto"
            />
            <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFn"
                (optionSelected)="getCliente($event.option.value)"
            >
                <mat-option *ngFor="let cliente of filteredOptions | async" [value]="cliente">
                    <span> {{ cliente.nome }}</span> |
                    <small>Conta: {{ cliente.numero_xp }}</small>
                </mat-option>
            </mat-autocomplete>
            <mat-icon matSuffix class="secondary-text" *ngIf="!loadingSpinner">account_circle</mat-icon>
            <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
        </mat-form-field>
    </div>

    <div fxLayout="row wrap">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Assunto</mat-label>
            <input matInput *ngIf="data" [value]="data.nome_assunto" [readonly]="true" />
            <mat-select placeholder="Ação" [formControl]="acao_id" name="acao_id" *ngIf="!data">
                <mat-option value="">SELECIONE</mat-option>
                <mat-option *ngFor="let acao of listAcao" [value]="acao.id">{{ acao.nome }}</mat-option>
            </mat-select>

            <mat-error *ngIf="acao_id.invalid">{{ getErrorAcaoMessage() }}</mat-error>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerAcao && !data"></mat-spinner>
        </mat-form-field>
    </div>

    <div fxLayout="row wrap">
        <mat-form-field style="width: 100%" appearance="outline">
            <mat-label>Resposta</mat-label>
            <textarea matInput placeholder="Resposta" [formControl]="resposta" required [rows]="5"></textarea>
            <mat-error *ngIf="resposta.invalid">{{ getErrorRespostaMessage() }}</mat-error>
        </mat-form-field>
    </div>

    <div fxLayout="row wrap" *ngIf="data.valor_sugerido !== '0.00'">
        <div style="display: flex; align-items: center; margin-bottom: 16px">
            <label style="font-size: 16px; margin-right: 8px">Cliente Aceitou:</label>
            <!-- todo: appearance="outline" -->
            <mat-button-toggle-group [(ngModel)]="cliente_aceitou" aria-label="Cliente Aceitou">
                <mat-button-toggle [value]="false">Não</mat-button-toggle>
                <mat-button-toggle [value]="true">Sim</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </div>
    <div *ngIf="cliente_aceitou">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="15">
            <mat-label>Valor</mat-label>
            <input
                matInput
                placeholder="Valor"
                [formControl]="valor"
                required
                currencyMask
                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                maxlength="50"
            />
        </mat-form-field>
    </div>
</div>

<div fxLayout="column" class="mb-24 mt-24" style="margin: 0px 24px">
    <div>
        <!-- Botão para selecionar arquivo -->
        <button type="button" color="primary" mat-raised-button (click)="fileInput.click()">Anexar Arquivo</button>

        <input
            hidden
            type="file"
            #fileInput
            multiple
            (change)="onFileSelected($event)"
            accept=".xls,.xlsx,.pdf,.csv,.png,.jpeg,.jpg,.svg,.txt,.doc,.docx,.csi"
        />
    </div>

    <div fxLayout="row wrap">
        <mat-list *ngIf="arquivosSelecionados.length > 0">
            <mat-list-item *ngFor="let arquivo of arquivosSelecionados; let i = index">
                <span>{{ arquivo.name }}</span>
                <button mat-icon-button color="warn" (click)="removerArquivo(i)">
                    <mat-icon>delete</mat-icon>
                </button>
            </mat-list-item>
        </mat-list>
    </div>
</div>

<div fxLayout="row wrap" *ngIf="isVisibleAgendamentoFuturo" style="margin: 0px 24px">
    <fieldset
        fxLayout="row wrap"
        fxLayoutAlign="space-between"
        fxFlex="100"
        style="margin-bottom: 10px; border-color: #eee"
    >
        <legend>Nova Tarefa</legend>
        <div fxFlex="100" style="margin-bottom: 24px; text-align: center">
            <!-- todo: Removido appearance="outline" -->
            <mat-button-toggle-group
                [(ngModel)]="isOportunidade"
                (change)="onToggleChange()"
                aria-label="Tipo de Negócio"
                style="display: inline-flex; justify-content: center"
            >
                <mat-button-toggle [value]="false">Relacionamento</mat-button-toggle>
                <mat-button-toggle [value]="true">Oportunidade</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="36">
            <mat-label>Assunto</mat-label>

            <mat-select placeholder="Assunto" [(value)]="model.assunto_id" [formControl]="assunto_id" name="assunto_id">
                <mat-option value="">SELECIONE</mat-option>
                <mat-option *ngFor="let assunto of listAtividade" [value]="assunto.id">{{ assunto.nome }}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerTipo"></mat-spinner>
        </mat-form-field>
        <mat-form-field [fxFlex]="isOportunidade ? '22' : '37'" appearance="outline" floatLabel="always">
            <mat-label>Descrição</mat-label>
            <textarea
                style="width: 100%"
                matInput
                placeholder="Descrição"
                [formControl]="observacao"
                required
                [rows]="1"
            ></textarea>
        </mat-form-field>

        <mat-form-field *ngIf="isOportunidade" appearance="outline" floatLabel="always" fxFlex="15">
            <mat-label>Valor</mat-label>
            <input
                matInput
                placeholder="Valor"
                [formControl]="valor_sugerido"
                required
                currencyMask
                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                maxlength="50"
            />
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" fxFlex="15">
            <mat-label>Data</mat-label>
            <input
                matInput
                [min]="todayDate"
                [matDatepicker]="retorno"
                [formControl]="data_follow_up"
                name="data_follow_up"
                required
                placeholder="Retornar em"
                [readonly]="true"
            />
            <mat-datepicker-toggle matSuffix [for]="retorno"></mat-datepicker-toggle>
            <mat-datepicker #retorno></mat-datepicker>
        </mat-form-field>

        <button
            mat-mini-fab
            color="white"
            matTooltip="ADICIONAR OPORTUNIDADE"
            (click)="addOportunidade()"
            [disabled]="isInvalidFormOportunidade()"
            class="add-product-button fuse-white mt-24 mt-md-0"
            style="margin-top: 1.5rem !important"
        >
            <mat-icon color="white">add</mat-icon>
            <span></span>
        </button>
        <mat-card fxLayout="column" fxFlex="100">
            <mat-card-content>
                <ngx-datatable
                    #tableRelacionamento
                    class="material striped"
                    [loadingIndicator]="loadingIndicatorOportunidade"
                    [columns]="columns"
                    [columnMode]="'force'"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    [rowHeight]="'auto'"
                    [rows]="rows"
                    [limit]="params.per_page"
                >
                    <ngx-datatable-column name="Data" prop="created_at" [sortable]="false" [width]="100">
                        <ng-template let-rowIndex="rowIndex" let-created_at="value" ngx-datatable-cell-template>
                            {{ created_at | date: "dd/MM/yyyy" }}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Assunto" prop="nome_assunto" [sortable]="false">
                        <ng-template let-rowIndex="rowIndex" let-nome_assunto="value" ngx-datatable-cell-template>
                            {{ nome_assunto }}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Descrição" prop="observacao" [sortable]="false">
                        <ng-template let-rowIndex="rowIndex" let-observacao="value" ngx-datatable-cell-template>
                            {{ observacao }}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Valor" prop="valor_sugerido" [sortable]="false">
                        <ng-template let-rowIndex="rowIndex" let-valor_sugerido="value" ngx-datatable-cell-template>
                            R$ {{ valor_sugerido ? valor_sugerido : (0 | number: "1.2-2") }}
                        </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="Data Retorno" prop="data_hora_atividade" [sortable]="false">
                        <ng-template
                            let-rowIndex="rowIndex"
                            let-data_hora_atividade="value"
                            ngx-datatable-cell-template
                        >
                            {{ data_hora_atividade | date: "dd/MM/yyyy" }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Ações" prop="id" [sortable]="false" [width]="80">
                        <ng-template let-rowIndex="rowIndex" let-id="value" ngx-datatable-cell-template>
                            <button
                                mat-icon-button
                                color="warn"
                                matTooltip="Excluir Contato Futuro"
                                (click)="deleteOportunidade(id)"
                                [disabled]="data.only_show"
                            >
                                <mat-icon aria-label="Excluir Contato Futuro">delete</mat-icon>
                            </button>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
                <div style="padding: 5px 10px">
                    <mat-paginator
                        #paginator
                        [length]="length"
                        [pageSize]="pageSize"
                        [pageSizeOptions]="pageSizeOptions"
                        (page)="pageEvent($event)"
                    >
                    </mat-paginator>
                </div>
            </mat-card-content>
        </mat-card>
    </fieldset>
</div>

<div mat-dialog-actions>
    <button mat-flat-button tabindex="2" [disabled]="canCancel()" (click)="onNoClick()" color="warn">Cancelar</button>

    <button mat-flat-button tabindex="2" [disabled]="canCancel()" (click)="addContatoFuturo()" color="primary">
        Adicionar Contato Futuro
    </button>

    <button mat-flat-button tabindex="2" [disabled]="isInvalidForm()" (click)="salvar(false)" color="primary">
        Salvar e Finalizar
    </button>
</div>
